import RegistPaymentComp from "../../../components/mypage/payment/RegistPaymentComp";

function RegistPayment() {

  return (
    <RegistPaymentComp/>
  );
}

export default RegistPayment;